export const SET_CAPSULE_CLASSES = "SET_CAPSULE_CLASSES";
export const UPDATE_PRODUCT_CAPSULE_COUNT = "UPDATE_PRODUCT_CAPSULE_COUNT";
export const SET_ACTIVE_PRIMARY_CLASS = "SET_ACTIVE_PRIMARY_CLASS";
export const SET_ACTIVE_SECONDARY_CLASS = "SET_ACTIVE_SECONDARY_CLASS";
